import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconSaving from '../../../Icons/IconSaving';
import IconCar from '../../../Icons/IconCar';
import { useAppStore } from '../../../store/AppContext';
import Filters from '../Components/Filters';
import { useValeContext } from '../context/Vale.context';

const BodyTop = ({
  urlMDScrollPreferencia,
  view,
  filtrosVisiblesProductos,
  filtrosVisiblesOtros,
}) => {
  const { t } = useTranslation();
  const [filtersOpen, setFiltersOpen] = useState<boolean>(false);
  const dataApp = useAppStore();
  const { changeOpenFilter, existenFiltrosvisibles } = useValeContext();
  const toggleFiltersOpen = () => {
    setFiltersOpen((prevFiltersOpen) => !prevFiltersOpen);
    changeOpenFilter();
  };
  return (
    <>
      <section className="o-section--no-padding-top section--background">
        <div className="container">
          <div className="cabecera-seccion">
            <div className="titulo-seccion">
              <h1 className="titulo-seccion__title">
                {t('vales.title-caprabo')}
              </h1>
              {view && (
                <>
                  <div className="titulo-seccion__deco" />
                  <div className="titulo-seccion__num" />
                </>
              )}
            </div>

            <div className="links-cabecera">
              <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet a-movil">
                <a
                  href={`${process.env.REACT_APP_CLUB_CAPRABO}${dataApp.lang}/clubcaprabo/mas-promociones/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-link u-align-items-baseline"
                >
                  <div className="icon icon-medium icon--grey ">
                    <IconSaving />
                  </div>
                  <span className="u-font-small u-text-brand u-text-decoration-underline">
                    {t('vales.promotion')}
                  </span>
                </a>
              </div>

              <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet a-movil">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href={`${process.env.REACT_APP_CAPRABO_CASA}`}
                  className="icon-link u-align-items-baseline"
                >
                  <div className="icon icon-medium icon--grey ">
                    <IconCar />
                  </div>
                  <span className="u-font-small u-text-brand u-text-decoration-underline">
                    {t('caprabo.saldo.capraboacasa')}
                  </span>
                </a>
              </div>

              <div className="icon-link-block">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href={urlMDScrollPreferencia}
                  className="icon-link u-align-items-baseline"
                >
                  {t('caprabo.cupones.preferencia.link-vales')}
                </a>
              </div>

              {existenFiltrosvisibles() ? (
                <div className="icon-link-block u-margin-bottom-small u-margin-top-small u-text-right u-display-none-only-mobile-tablet">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={toggleFiltersOpen}
                  >
                    {t('caprabo.cupones.txtBtnFiltrar')}
                  </button>
                </div>
              ) : null}

              <div className="icon-link-block" />
            </div>
          </div>
        </div>
      </section>

      <Filters
        toggleFiltersOpen={toggleFiltersOpen}
        filtersOpen={filtersOpen}
        filtrosVisiblesProductos={filtrosVisiblesProductos}
        filtrosVisiblesOtros={filtrosVisiblesOtros}
      />
    </>
  );
};

export default BodyTop;
